import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-mandanten-statistik',
  templateUrl: './manage-mandanten-statistik.component.html',
  styleUrls: ['./manage-mandanten-statistik.component.scss']
})
export class ManageMandantenStatistikComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
